<template>
  <div>
    <div class="loader" v-show="loader">
      <spinner />
    </div>
    <div v-show="!loader" id="report" class="report"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import * as pbi from 'powerbi-client';
import spinner from '@/components/atoms/loader/index.vue';

export default {
  name: 'ReportPbi',
  computed: {
    ...mapState('users', ['user']),
  },
  components: {
    spinner,
  },
  props: {
    reportId: {
      type: String,
      required: true,
    },
    groupId: {
      type: String,
      required: true,
    },
    pageName: {
      type: String,
    },
    usernameReport: {
      type: String,
    },
  },
  data: () => ({
    userAuth: null,
    loader: true,
    embedUrl: null,
    embedToken: null,
    report: null,
    container: null,
  }),
  methods: {
    ...mapActions('users', ['getUser']),
    async embedPowerBi() {
      // eslint-disable-next-line
      const models = pbi.models;
      const permissions = models.Permissions.All;

      let filterPaneEnabled = false;
      let navContentPaneEnabled = true;
      if (this.reportId === '8d572917-d339-4baa-97bb-d31dff06221e') { // veículos usados
        filterPaneEnabled = true;
        navContentPaneEnabled = true;
      } else if (
        this.reportId === 'de93db8e-fcc3-47e8-95c1-cc1bab661bc6' // Relatórios SFATs
        || this.reportId === 'ea016fbb-8742-4b0e-b41d-e414ce0ec248' // Retiradas Rede
        || this.reportId === 'e46c2a1c-290d-4ff1-8f48-39ea6cda2ef1' // varejo
        || this.reportId === '419b2961-9cae-4084-86af-cb112a64c5fe' // frota circulaante
        || this.reportId === '1a68fb92-405d-4e67-8041-9d41a510bc4b' // PSP - Potencial de Peças
        || this.reportId === 'e4affcbb-3fe7-491c-b0b9-d60f8c34e9e3') { // PSP - Potencial de Serviços
        filterPaneEnabled = true;
        navContentPaneEnabled = false;
      } else if (
        // this.reportId === '9ddfe77b-99d8-49e0-b028-24b7661408cd' // DimensionamenTool
        this.reportId === '9c16a973-276e-4bb5-ba0d-99d620e87622' // TrocaRapida
        || this.reportId === '512302d7-b53e-4abf-88e7-0f9626f73c61' // PrecosComparativo
        // || this.reportId === '9eb09bc4-0c31-40ed-ae2a-0c361055b5d7' // DashboardS24h
        || this.reportId === '03d94e33-8563-435d-89ed-afe9cb9e5809' // Lista de Preços
        || this.reportId === 'f37f1e23-b2e4-4ec8-a9e7-a2aa2c215bda' // Torre de Controle
        || this.reportId === '9ad72920-33cf-4e0b-ac59-f734fdd5ac76' // Ativação Conectividade
        || this.reportId === '53d1148c-0f9a-44ad-b598-98cdfae3ac67' // Ações de Campo
        || this.reportId === 'c49919c3-d5a0-44b5-92fe-8bf47aad2983' // MEF
        || this.reportId === '29bc1892-90df-4513-bb76-1784e524b66e' // Marketplace de peças – Estoque Parado
        || this.reportId === 'b0c64ac7-1a03-4ec2-95b2-e50c92c7b283' // PSP - Potencial de Lubrificantes
        || this.reportId === 'ddf4e4f3-cd29-4df8-8137-65ed6b0e153b' // Retenção
        || this.reportId === 'dd6ca436-3158-48ba-b27b-ec690aa93e5d') { // Disponibilidade de Peças
        navContentPaneEnabled = false;
      }
      // eslint-disable-next-line
      powerbi.embed(this.container, {
        type: 'report',
        id: this.report,
        embedUrl: `${this.embedUrl}${
          this.pageName ? `&pageName=${this.pageName}` : ''
        }`,
        tokenType: models.TokenType.Embed,
        accessToken: this.embedToken,
        permissions,
        settings: {
          filterPaneEnabled,
          navContentPaneEnabled,
        },
      });
    },
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
    await this.getUser({ id: this.userAuth.id, token: this.userAuth.token });

    this.container = document.getElementById('report');
    let url;
    if (
      // this.reportId === '9ddfe77b-99d8-49e0-b028-24b7661408cd' // DimensionamenTool
      this.reportId === '9c16a973-276e-4bb5-ba0d-99d620e87622' // TrocaRapida
      || this.reportId === 'c49919c3-d5a0-44b5-92fe-8bf47aad2983' // MEF
    ) {
      url = `https://powerbi.idcx-verse.com/?reportId=${
        this.reportId
      }&groupId=${
        this.groupId
      }&roles=SecurityLevel&accessLevel=View`;
    } else if (this.user.type === 'dealer'
      || this.reportId === 'b07a169f-ee4f-4b87-a26b-05eb4b1dc218' // Estoque Rede
      || this.reportId === 'de93db8e-fcc3-47e8-95c1-cc1bab661bc6' // Relatórios SFAT
      || this.reportId === '512302d7-b53e-4abf-88e7-0f9626f73c61' // PrecosComparativo
    ) {
      url = `https://powerbi.idcx-verse.com/?reportId=${
        this.reportId
      }&groupId=${
        this.groupId
      }&roles=SecurityLevel&credentials=true&accessLevel=View&usernameReport=${
        this.user.email
      }`;
    } else {
      url = `https://powerbi.idcx-verse.com/?reportId=${
        this.reportId
      }&groupId=${this.groupId}`;
    }

    axios
      .get(url)
      // eslint-disable-next-line
      .then((response) => {
        this.loader = false;
        this.embedUrl = response.data.EmbedURL;
        this.embedToken = response.data.EmbedToken;
        this.report = response.data.ReportId;
        this.embedPowerBi();
      })
      .catch();

    // if (this.user.type === 'master') {
    //   axios
    //     .get(
    //       this.usernameReport
    //         ? `https://powerbi.idcx-verse.com/?reportId=${this.reportId}&groupId=${this.groupId}&roles=LawyerLevel&accessLevel=View&credentials=true&usernameReport=${this.usernameReport}`
    //         : `https://powerbi.idcx-verse.com/?reportId=${this.reportId}&groupId=${this.groupId}`,
    //     )
    //     // eslint-disable-next-line
    //     .then(response => {
    //       this.loader = false;
    //       this.embedUrl = response.data.EmbedURL;
    //       this.embedToken = response.data.EmbedToken;
    //       this.report = response.data.ReportId;
    //       this.embedPowerBi();
    //     })
    //     .catch();
    // } else {
    //   axios
    //     .get(
    //       `https://powerbi.idcx-verse.com/?reportId=${
    //         this.reportId
    //       }&groupId=${this.groupId}&roles=${
    //         this.reportId === 'cd4e4fec-ce85-46a2-993e-8dbdd7b6aabb' ||
    //         this.reportId === '61bfdeb5-69c9-486c-893c-8aa1ad131b16'
    //           ? 'SecurityLevel'
    //           : 'LawyerLevel'
    //       }&accessLevel=View&credentials=true&usernameReport=${
    //         this.reportId === 'cd4e4fec-ce85-46a2-993e-8dbdd7b6aabb' ||
    //         this.reportId === '61bfdeb5-69c9-486c-893c-8aa1ad131b16'
    //           ? this.user.email
    //           : this.usernameReport
    //       }`,
    //     )
    //     // eslint-disable-next-line
    //     .then(response => {
    //       this.loader = false;
    //       this.embedUrl = response.data.EmbedURL;
    //       this.embedToken = response.data.EmbedToken;
    //       this.report = response.data.ReportId;
    //       this.embedPowerBi();
    //     })
    //     .catch();
    // }
  },
};
</script>

<style lang="scss">
.report {
  height: 800px;
  max-height: 800px;
  iframe {
    display: block;
    border: none;
    height: 100vh;
    width: 100vw;
  }
}

.loader {
  width: 100%;
  height: calc(100vh - 95px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
